import gql from 'graphql-tag';

export default gql`
    query geocodeLocation($placeId: String!) {
        viewer {
            id,
            geocodeLocation(placeId: $placeId) {
                street,
                city,
                state,
                postalCode,
                country
            }
        }
    }
`;
